export class MyBookingDetailModel {
    bookingId: number;
    bookingStatus: string;
    bookingDate: Date;
    checkInDate: any;
    checkOutDate: any;
    approvalDate: Date;
    checkInTimeFrom: string;
    checkInTimeUntil: string;
    checkOutTimeFrom: string;
    checkOutTimeUntil: string;
    wsReference: string;
    supplierName: string;

    roomTypes: RoomType[];
    hotelRemarks: string[];
    bookerInformation: BookerInformation[];
    hotelInformation: HotelInformation;
    bookingPayment: BookingPayment;
    bookingCancellationCharge: BookingCancellationCharge;
    documents: string[];
    arrivalTime: string;

    paymentType: string;
    travellerInformation: TravellerInformation[];
    reason: string;
    limitOccupancy: LimitOccupancy[];
}
export class BookerInformation {
    fullName: string;
    phone: string;
    email: string;
    mainBooker: boolean;
    creditCardInformation?: CreditCardInformation;
    creditTermsInformation?: CreditTermsInformation;
    trueMoneyInformation?: TrueMoneyInformation;
    corporateFleetCardInformation?: FleetInformation;
    personalFleetCardInformation?: FleetInformation;
    qrCodeInformation?: QRCodeInformation;
    eWalletInformation?: EWalletInformation;
    imBankingInformation?: IMBankingInformation;
    payAtCounterInformation?: PayAtCounterInformation;
    checkoutFields?: CheckoutField[];
}

export class BookerPaymentInformation {
    bookingApproval?: BookingApproval;
    taxAddressInformation?: TaxAddressInformation;
    cancellationCharge: CancellationCharge;
    paymentInformation: PaymentInformation;
}

export class HotelInformation {
    hotelId: number;
    name: string;
    address: string;
    star: number;
    latitude: number;
    longitude: number;
    phone: string;
    hotelImage: string;
    remarks: string[];
}

export class BookingApproval {
    fullName: string;
    email: string;
}

export class TaxAddressInformation {
    taxName: string;
    taxId: number;
    taxAddress: string;
}

export class RoomType {
    roomTypeName: string;
    guests: string;
    maxAdult: number;
    maxChild: number;
    specialRequest: string;
    breakfast: Boolean;
    offerTypeName: string;
    offerTypeDisplay: string;
    freeCancellationDate: Date;
    price: number;
    extraBed: number;
    benefits: Benefit[];
    surcharges: Surcharge[];
    cancellationPolicies?: CancellationPolicy[];
}

export class CancellationCharge {
    cancellationFee: number;
    cancellationFeeVat: number;
    cancellationFeeExVat: number;
    refundAmount?: number;
}

export class Surcharge {
    charge: string;
    name: string;
    price: number;
}

export class MyBookingDownloadDocument {
    bookingId: number;
    documentType: string;
}

export class CreditCardInformation {
    taxAddressInformation: TaxAddressInformation;
    cancellationCharge: CancellationCharge;
    paymentInformation: PaymentInformation;
}

export class FleetInformation {
    cancellationCharge: CancellationCharge;
    paymentInformation: PaymentInformation;
}

export class TrueMoneyInformation {
    taxAddressInformation: TaxAddressInformation;
    cancellationCharge: CancellationCharge;
    paymentInformation: PaymentInformation;
}

export class QRCodeInformation {
  taxAddressInformation: TaxAddressInformation;
  cancellationCharge: CancellationCharge;
  paymentInformation: PaymentInformation;
}

export class EWalletInformation {
  taxAddressInformation: TaxAddressInformation;
  cancellationCharge: CancellationCharge;
  paymentInformation: PaymentInformation;
}

export class IMBankingInformation {
  taxAddressInformation: TaxAddressInformation;
  cancellationCharge: CancellationCharge;
  paymentInformation: PaymentInformation;
}

export class PayAtCounterInformation {
  taxAddressInformation: TaxAddressInformation;
  cancellationCharge: CancellationCharge;
  paymentInformation: PaymentInformation;
}

export class PaymentInformation {
    totalPrice: number;
    discount?: number;
    totalPriceExcludeVat: number;
    totalVat: number;
    vat: number;
    currencyCode: string;
}

export class CreditTermsInformation {
    bookingApproval?: BookingApproval;
    taxAddressInformation: TaxAddressInformation;
    cancellationCharge: CancellationCharge;
    paymentInformation: PaymentInformation;
}

export class BookingPayment {
    paymentMethod: string;
    payOnDate: Date;
    totalPrice: number;
    discount?: number;
    totalPriceExcludeVat: number;
    totalVat: number;
    vat: number;
    currencyCode: string;
    paymentErrorCode?: string;
    paymentMethodDetail: PaymentMethodDetail;
    paymentMethodDisplay: string;
    taxesAndFees: number;
}

export class PaymentMethodDetail {
    mainPaymentMethod: string;
    mainPaymentMethodDisplay: string;
    anotherPaymentMethod?: string;
    anotherPaymentMethodDisplay?: string;
    mainPaymentMethodStatus?: string;
    anotherPaymentMethodStatus?: string;
    mainPaymentInformation?: PaymentInformation;
    anotherPaymentInformation?: PaymentInformation;
}

export class BookingCancellationCharge {
    cancelDate: Date;
    cancellationFee: number;
    totalVat: number;
    vat: number;
    refundAmount: number;
    cancelName: string;
    cancellationFeeVat: number;
    cancellationFeeExVat: number;
    mainPaymentCancellationCharge?: CancellationCharge;
    anotherPaymentCancellationCharge?: CancellationCharge;
}

export class CancellationPolicy {
    fromDate: Date;
    cancelFee: number;
}

export class Benefit {
    name: string;
    nameTh: string;
    description: string;
    descriptionTh: string;
}

export class TravellerInformation {
    roomTypeName: string;
    travellers: Traveller[]
}

export class Traveller {
    name: string;
    checkoutFields: CheckoutField[];
    approval: Approval;
}

export class CheckoutField {
    fieldId: string;
    displayName: string;
    value: string;
}

export class Approval {
    approvalName: string;
    approvalEmail: string;
    approvalStatus: string;
}

export class LimitOccupancy {
  adult: number;
  children: number;
  childrenAge: number[];
}



// WEBPACK FOOTER //
// ./src/app/model/booking/my-booking-model-v2.ts